module.exports = __webpack_public_path__ + "media/images/youtube-white-icon-97dbb698ab85571431c10e7f6d97b902.png";